import { render, staticRenderFns } from "./notify-item.vue?vue&type=template&id=01aeb9dd&scoped=true"
import script from "./notify-item.vue?vue&type=script&lang=js"
export * from "./notify-item.vue?vue&type=script&lang=js"
import style0 from "./notify-item.styl?vue&type=style&index=0&id=01aeb9dd&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aeb9dd",
  null
  
)

export default component.exports